import React from "react";
import { Animated } from "react-animated-css";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import MapBackBtn from "../../components/mapBackBtn/mapBackBtn.component";
import SubmitReqLeftCol from "../../containerSmall/submitReqLeftCol/submitReqLeftCol.component";
import SubmitReqRightCol from "../../containerSmall/submitReqRightCol/submitReqRightCol.component";
import { SubmitReqStyled } from "./submitReq.styles";

import {
  selectNewRequestCalenderBargiry_show,
  selectNewRequestCalenderTakhlieh_show,
} from "../../redux/newRequest/newRequest.selectors";
import Calender from "../../containerSmall/calender/calender.component";
console.log(selectNewRequestCalenderTakhlieh_show)
const SubmitReq = ({
  selectNewRequestCalenderBargiry_show,
  selectNewRequestCalenderTakhlieh_show,
}) => {
  return (
    <Animated
      animationIn="zoomInUp"
      animationOut="bounceOutUp"
      animationInDuration={500}
      animationOutDuration={500}
      isVisible={true}
      className="animated position-relative"
    >
      {/* <div className="position-relative"> */}
      <MapBackBtn />
      <SubmitReqStyled>
        {selectNewRequestCalenderBargiry_show ||
        selectNewRequestCalenderTakhlieh_show ? (
          <Calender />
        ) : (
          <SubmitReqRightCol />
        )}
        <SubmitReqLeftCol />
      </SubmitReqStyled>
      {/* </div> */}
    </Animated>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestCalenderBargiry_show: selectNewRequestCalenderBargiry_show,
  selectNewRequestCalenderTakhlieh_show: selectNewRequestCalenderTakhlieh_show,
});

export default connect(mapStateToProps)(SubmitReq);
